import { $color_grey_9, $color_grey_5, $color_grey_4, $color_grey_2, $color_grey_8, $color_grey_7, $color_grey_6 } from '../pebbleGlobalToken/color.js';
import { $shadow_0 } from '../pebbleGlobalToken/shadow.js';

/**
 * 输入框-最深的文本色。为了符合W3C标准，默认的文本颜色使用了该色，同时这个颜色也是最深的中性色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $input_color_text = $color_grey_9;

/**
 * 输入框-默认使用的边框颜色, 用于分割不同的元素，例如：表单的分割线、卡片的分割线等。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $input_color_border = $color_grey_5;

/**
 * 输入框-控制禁用状态下的边框颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $input_color_border_disabled = $color_grey_4;

/**
 * 输入框-控制禁用状态下的字体颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $input_color_text_disabled = $color_grey_4;

/**
 * 输入框-控制容器在禁用状态下的背景色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $input_color_bg_container_disabled = $color_grey_2;

/**
 * 输入框-较小的组件高度
 * @description enDesc: -
 * @description type: Font
 * @description value: 28
 */
var $input_control_height_sm = 28;

/**
 * 输入框-较高的组件高度
 * @description enDesc: -
 * @description type: Font
 * @description value: 40
 */
var $input_control_height_lg = 40;

/**
 * 输入框-hover状态颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $input_color_hover = $color_grey_9;

/**
 * 输入框-border hover下的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $input_color_border_hover = $color_grey_8;

/**
 * 输入框-选中态的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $input_color_active = $color_grey_9;

/**
 * 输入框-边框选中的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $input_color_border_active = $color_grey_9;

/**
 * 输入框-边框选中阴影
 * @description enDesc: -
 * @description type: Shadow
 * @description value: $shadow_0
 */
var $input_shadow_active = $shadow_0;

/**
 * 输入框-只读的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-7
 */
var $input_color_readonly = $color_grey_7;

/**
 * 输入框-错误状态的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $input_color_error = $color_grey_5;
/**
 * 输入框-placeholder颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $input_color_placeholder = $color_grey_6;

export { $input_color_active, $input_color_bg_container_disabled, $input_color_border, $input_color_border_active, $input_color_border_disabled, $input_color_border_hover, $input_color_error, $input_color_hover, $input_color_placeholder, $input_color_readonly, $input_color_text, $input_color_text_disabled, $input_control_height_lg, $input_control_height_sm, $input_shadow_active };
